import React, { FC, useEffect, useContext } from "react";

import AddReqsActionModal from "./AddRequisitionsModal";
import ChangeStatusModal from "./ChangeStatusModal";
import RejectCandidateModal from "./RejectModal";
import MoveCandidateModal from "./MoveCandidateModal";
import SendMessageModal from "./SendMessageModal";
import SendNotesModal from "./SendNotesModal";
import CandidateListContext from '../../contexts/candidate/candidateListContext';

interface ActionModalProps {
  open: boolean;
  setOpenModal: any;
  candidateService: any;
  openAction: any;
  selectType: string;
  resetOpenAction?: () => void
}
const CandidateActionsModal: FC<ActionModalProps> = ({
  open,
  setOpenModal,
  candidateService,
  openAction,
  selectType,
  resetOpenAction,
}) => {

const candidateContext = useContext(CandidateListContext);

  useEffect(() => {
    const validateCandidates = () => {
      let postData = {
        data: candidateContext.selectedCandidate,
        action: openAction.payLoadName,
      };
      candidateService.validateCandidateDetails(postData, (response: any) => {
        candidateContext.setValidatedCandidateList(response.data || []);
      });
    };
    if (openAction.payLoadName !== '') {
      validateCandidates();
    }
  }, [openAction.payLoadName, candidateContext.selectedCandidate]);

  const handleClose = () => {
    setOpenModal(false);
    if (typeof resetOpenAction === 'function') {
      resetOpenAction()
    }
    candidateContext.setValidatedCandidateList([])
  };
  return (
    <>
      {openAction.name === "ADD_TO_REQUISITION" && (
        <AddReqsActionModal open={open} onClose={handleClose} />
      )}
      {openAction.name === "CHANGE_STATUS" && candidateContext.candidateCanChangeStatus && (
        <ChangeStatusModal open={open} onClose={handleClose} />
      )}
      {openAction.name === "SEND_NOTE" && (
        <SendNotesModal open={open} onClose={handleClose} />
      )}
      {openAction.name === "REJECT" && (
        <RejectCandidateModal open={open} onClose={handleClose} />
      )}
      {openAction.name === "SEND_MESSAGE" && (
        <SendMessageModal open={open} onClose={handleClose} />
      )}
      {openAction.name === "MOVE_CANDIDATE" && (
        <MoveCandidateModal open={open} onClose={handleClose} />
      )}
    </>
  );
};

export default CandidateActionsModal;
